<div *ngIf="showModal" class="fixed inset-0 bg-primary bg-opacity-95 flex items-center justify-center z-999">
  <div class="relative w-full h-full max-h-screen px-4 sm:px-8 pt-20 overflow-auto">
    <button class="absolute top-1 right-4 text-white hover:text-black text-8xl" (click)="close()">
      &times;
    </button>
    <div class="w-full flex flex-col items-center lg:mt-20">
      <div class="bg-white rounded-3xl py-6 px-4 sm:px-8 sm:py-8 shadow-lg w-full max-w-full sm:max-w-3xl">
        <h1 class="text-primary-500 text-center font-montserrat font-bold text-2xl leading-tight pb-2 md:text-5xl sm:text-4xl">
          {{headerTitle}}
        </h1>
        <br>
        <p class="text-primary text-center font-montserrat text-base sm:text-lg leading-relaxed font-bold pb-10 px-5 flex-nowrap whitespace-pre-line">
          {{headerBody}}
        </p>
        <!-- Coverage check content goes here -->
        <div class="w-full flex justify-center items-center">
          <app-google-search-bar class="w-full" [hasWhiteBackground]="true"></app-google-search-bar>
        </div>
      </div>
    </div>
  </div>
</div> 